import $ from "jquery"
import AudioPlayerView from "views/audio_player_view"

// Builds the player UI around every `audio` element in `scope`. Content added
// after the page has loaded needs this too, because CSS hides a bare `audio`
// element and the player is what makes it playable.
//
// `AudioPlayerView` skips an element it has already initialised, so running
// this over the same scope twice is safe.
export default function initAudioPlayers(scope = document) {
  $("audio", scope).each((i, el) => new AudioPlayerView({ audioEl: el }))
}
